var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "110px",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    viewBox: "0 0 110 110",
    width: "110px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Multicolor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    style: {
      fill: "#FABC3D"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "67,67.997 65,66.997 45,66.997 43,67.997 55,87    ",
    style: {
      fill: "#E2E4E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70,45c-1,0-1,1.111-1,1.111V45c-0.002-1.065-0.019-2.086-0.067-3.062C64.891,38.001,55,38,55,38    s-9.891,0.001-13.933,3.938C41.019,42.914,41.002,43.935,41,45v7.997l4,10l5.105,3.996c0.569,0.639,1.384,1.004,2.24,1.004H55    h2.655c0.856,0,1.671-0.365,2.24-1.004L65,62.997l3.207-8.017C71.042,54.776,72,50.476,72,47.222C72,46.111,71,45,70,45z",
    style: {
      fill: "#F8E1C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,45v1.111c0,0,0-1.111-1-1.111s-2,1.111-2,2.222c0,3.253,0.958,7.554,3.793,7.758L45,62.997    l5.105,3.996c0.569,0.639,1.384,1.004,2.24,1.004H55V38c0,0-9.891,0.001-13.933,3.938C41.019,42.914,41.002,43.935,41,45z",
    style: {
      fill: "#FCF1E2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,56.997h10c0,0,0,3-5,3S50,56.997,50,56.997z",
    style: {
      fill: "#F79392"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61,47.322c1.191,0,2.248,0.266,2.981,0.678c0.071-0.569-0.172-1.154-0.748-1.59     c-1.03-0.781-2.702-0.781-3.733,0c-0.464,0.352-0.709,0.801-0.753,1.26C59.389,47.451,60.164,47.322,61,47.322z",
    style: {
      fill: "#3E3E3F"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.993,47.322c-1.191,0-2.248,0.266-2.981,0.678c-0.071-0.569,0.172-1.154,0.748-1.59     c1.03-0.781,2.702-0.781,3.733,0c0.464,0.352,0.709,0.801,0.753,1.26C50.604,47.451,49.829,47.322,48.993,47.322z",
    style: {
      fill: "#3E3E3F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.655,67.997H55h-2.655c-0.856,0-1.671-0.365-2.24-1.004L45,62.997v4.5c0,0,0,7.5,10,7.5    s10-7.5,10-7.5v-4.5l-5.105,3.996C59.326,67.632,58.511,67.997,57.655,67.997z",
    style: {
      fill: "#F4D0A1"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55,38c0,0-0.758,0-1.938,0.083c0,1.25,0,4.243,0,5.625c3.719,0,5.972-2.684,7.274-5.234     C57.41,38.001,55,38,55,38z",
    style: {
      fill: "#3E3E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.919,39.332C44.022,39.922,42.228,40.772,41,42c0,3.542,2.323,5.25,2.323,5.25     C43.029,44.294,43.013,42.368,45.919,39.332z",
    style: {
      fill: "#3E3E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.865,39.062c0,0.954,0,2.799,0,4.647c2.865,0,5.149-4.054,5.918-5.604     C51.218,38.226,49.027,38.49,46.865,39.062z",
    style: {
      fill: "#3E3E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.344,40.205c0,0.387,0,4.515,0,7.045c2.488,0,2.646-4.661,2.655-5.25     C68.278,41.278,67.361,40.689,66.344,40.205z",
    style: {
      fill: "#3E3E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.917,38.771c0,1.695,0,3.526,0,4.938c3.354,0,4.325-3.171,4.418-3.508     C64.968,39.551,63.421,39.093,61.917,38.771z",
    style: {
      fill: "#3E3E3F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.105,66.993L45,62.997v4.5c0,0,0,7.5,10,7.5v-7h-2.655    C51.489,67.997,50.674,67.632,50.105,66.993z",
    style: {
      fill: "#F8E1C2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.491,53.445v-19.62c-0.697-0.249-1.368-0.493-2-0.728v20.348c-2.61,1.72-1,6.85-1,9.555     c0.995,0,1.544,0,1.842,0c0.064,0,0.116,0,0.158,0c0.13,0,0.168,0,0.158,0c0.297,0,0.847,0,1.842,0     C35.491,60.295,37.102,55.165,34.491,53.445z",
    style: {
      fill: "#FA5655"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,31c0-1-25-8-27-8s-27,7-27,8c0,0.625,7.432,3.207,13,5.053c0,1.724,0,3.768,0,5.947     c4-4,14-4,14-4s10,0,14,4c0-2.18,0-4.223,0-5.947C74.568,34.207,82,31.625,82,31z",
    style: {
      fill: "#3E3E3F"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "66.965,68.059 67,68 65,67 55.015,71.981 60.808,77.807    ",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "59,87 56.201,76.8 58,75.002 54.981,71.978 51.983,74.976 53.801,76.793 51,87    ",
    style: {
      fill: "#DF2C2C"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "55,87 55,71.997 54.981,71.978 51.983,74.976 53.801,76.793 51,87    ",
    style: {
      fill: "#FA5655"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "43.035,68.059 43,68 45,67 54.985,71.981 49.192,77.807    ",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,87l4-11c0.615-1.333,1.698-2.394,3.043-2.983L43,68l12,19H23z",
    style: {
      fill: "#3E3E3F"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87,87l-4-11c-0.615-1.333-1.698-2.394-3.043-2.983L67,68L55,87H87z",
    style: {
      fill: "#3E3E3F"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "55,87 43,68 34,71 51,87    ",
    style: {
      fill: "#9E9FA0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "55,87 67,68 76,71 59,87    ",
    style: {
      fill: "#9E9FA0"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/student_icon.9a271d759354d5cd5d9a2a66d8f26260.svg";
export { ForwardRef as ReactComponent };